// extracted by mini-css-extract-plugin
export var compact = "_mz-2";
export var phoneFrame = "_mz-0";
export var phoneScreen = "_mz-1";